module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkAQMAAADbzgrbAAAAAXNSR0IArs4c6QAAAAZQTFRFAAAAl5eXDVANgAAAAAF0Uk5TAEDm2GYAAAAqSURBVAjXY2Cw/3+AgQFK4gD/geADlGRmYOBhIEQy89CWxGXv//9/oCQA8Y4WReFpBpkAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/myviews/shoppMall/activityPageSet/fullPlatformSetQuery/lowCode/assets/images/delete-icon.png
// module id = F/ya
// module chunks = 243